import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'mc0167',
    ecrans: ['00-2'],
    params: ['id']
});
